module.exports = __webpack_public_path__ + "img/production-rate-example@2x.1e35108c.png";